/** Shared floating panel styles (Popover, DropdownMenu, HoverCard, Select, Combobox). */
export const floatingPanel =
  'z-50 rounded-card border border-line bg-surface text-text shadow-pop outline-none ' +
  'data-[state=open]:animate-pop-in data-[state=closed]:animate-pop-out origin-(--radix-popper-transform-origin)'

/** Menu item row: h36 (40 below sm: phone tap targets, UI.md section 10, E2E-J10-06), px10, radius 8, hover surface-2. */
export const menuItem =
  'relative flex h-9 max-sm:h-10 w-full cursor-pointer items-center gap-2.5 rounded-lg px-2.5 text-body text-text outline-none select-none focus-visible:shadow-none ' +
  'transition-colors duration-100 data-[highlighted]:bg-surface-2 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 ' +
  '[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-muted [&_svg]:stroke-[1.75]'
